import React from 'react';
import Lottie from 'lottie-react';
import DevAnimation from '../../animation/Programming Computer.json'; 
import './hero.css';
import { motion } from 'framer-motion'; 
const Hero = () => {
  return (
    <section className="hero flex">
      {/* القسم الأيسر */}
      <div className="left-section border">
        <div className="parent-avatar flex">
          <img
            src="/fonts/undraw_workspace_s6wf.svg"
            className="avatar"
            alt="Developer at workspace"
          />
          <div className="fa fa-check-circle icon-verified" aria-hidden="true"></div>
        </div>

        <motion.h1 
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 2 }}
          className="title"
        >
          This portfolio showcases my front-end work and skills.
        </motion.h1>

        <p className="sub-title">
          I'm Zeinab Alaa, a driven front-end developer specializing in building
          elegant, performant, and accessible web applications. With a strong
          commitment to quality and innovation, I create seamless user experiences
          that solve real problems. This portfolio highlights my technical expertise,
          creative approach, and dedication to delivering impactful projects.
        </p>

        <div className="all-icons flex">
          <a
            href="https://www.linkedin.com/in/zienab-alaa-01a264376?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bcslni0O2TBWBLaU%2F%2BFIigg%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn Profile"
            title="LinkedIn"
          >
            <div className="fa fa-linkedin"></div>
          </a>
          <a
            href="https://github.com/ZienabAlaa"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub Profile"
            title="GitHub"
          >
            <div className="fa fa-github"></div>
          </a>
        </div>
      </div>

      {/* القسم الأيمن */}
      <div className="right-section animation border">
        <Lottie animationData={DevAnimation} loop={true} />
      </div>
    </section>
  );
};

export default Hero;
